import React, { useState } from "react";
import { useAdminPanel } from "./AdminPanelCore";

const AdminTask = () => {
  const {
    files,
    alerts,
    selectedFile,
    setSelectedFile,
    runProcess,
    dayjs,
    pushAlert, // use global alert handler
  } = useAdminPanel();

  const [loading, setLoading] = useState(false);

  const selectedFiles = selectedFile ?? null;

  // Toggle file selection
  const handleCheckboxChange = (fileId) => {
    setSelectedFile(fileId === selectedFiles ? null : fileId);
  };

  // Handle Task execution
  const handleRunTask = async () => {
    if (!selectedFiles) return;
  
    try {
      setLoading(true);
      const result = await runProcess("task");
  
      const insertedCount = parseInt(result?.rowsInserted ?? 0);
  
      if (insertedCount === 0) {
        pushAlert(
          "⚠️ Duplicate data: All rows already exist in the database.",
          "warning"
        );
      } else {
        pushAlert(
          `✅ TASK completed – ${insertedCount} row${insertedCount === 1 ? "" : "s"} inserted.`,
          "success"
        );
      }
    } catch (error) {
      console.error("❌ Task failed:", error);
  
      // Try to extract a detailed message
      const errorMsg =
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        error?.message ||
        "Unknown error occurred.";
  
      pushAlert(`❌ Task failed: ${errorMsg}`, "danger");
    } finally {
      setLoading(false);
    }
  };
  
  const sortedFiles = [...files].sort(
    (a, b) => new Date(b.uploadedAt) - new Date(a.uploadedAt)
  );

  return (
    <div className="container py-5 position-relative">
      {/* Loading overlay */}
      {/* {loading && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 bg-white bg-opacity-75 d-flex justify-content-center align-items-center"
          style={{ zIndex: 1050 }}
        >
          <div className="spinner-border text-success" role="status">
            <span className="visually-hidden">Processing...</span>
          </div>
        </div>
      )} */}

      {/* Global alerts only */}
      {alerts.map((a) => (
        <div key={a.id} className={`alert alert-${a.type} mb-4`}>
          {a.msg}
        </div>
      ))}

      <div className="card shadow-sm">
        <div className="card-body">
          <h4 className="card-title mb-4">📝 Select Files to Run Task</h4>

          {/* File list */}
          <div className="row">
            {sortedFiles.length > 0 ? (
              sortedFiles.map((file) => (
                <div className="col-md-6 col-lg-4 mb-3" key={file.id}>
                  <div className="form-check border rounded p-3 h-100">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id={`file-${file.id}`}
                      checked={selectedFiles === file.id}
                      onChange={() => handleCheckboxChange(file.id)}
                      disabled={loading}
                    />
                    <label
                      className="form-check-label ms-2"
                      htmlFor={`file-${file.id}`}
                    >
                      <strong>{file.name}</strong>
                      <br />
                      <small className="text-muted">
                        {dayjs
                          .utc(file.uploadedAt, "YYYY-MM-DD HH:mm:ss")
                          .format("DD MMM YYYY HH:mm")}
                      </small>
                    </label>
                  </div>
                </div>
              ))
            ) : (
              <div className="text-muted">No files uploaded yet.</div>
            )}
          </div>

          {/* Run button */}
          <div className="mt-4 text-end">
            <button
              className="btn btn-success px-4"
              disabled={!selectedFiles || loading}
              onClick={handleRunTask}
            >
              {loading ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Processing...
                </>
              ) : (
                "▶ Run Task"
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminTask;
